module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "pn"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Part I")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('h2', {
    staticClass: "pt"
  }, [_vm._v("FOR ALL BODIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is an offering of ways to look at human experience and interactions. It outlines a few ways to better understand people around you and to communicate in ways that allow you to be heard. Through these different vantage points, you may learn more about yourself and how you have come to interpret your life, beliefs, emotions, and understandings. There are also many other ways to view our connections to our bodies, thoughts, emotions, beliefs, and actions, as well as connections to cultures, spiritual practices, and modalities. I offer a few here as an invitation to understanding on a deeper level.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abc155aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Part01.vue
// module id = 78
// module chunks = 0